import { FollowOrder } from "./FollowOrder";

export default FollowOrder;
